// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"82":"c0f550a7","927":"dd273a22"}[chunkId] + ".css";
};